// Shared footer, matches the main page footer in index.html.

export function renderFooter(container = document.body) {
  const footer = document.createElement('footer');
  footer.className = 'footer';
  const year = new Date().getFullYear();
  footer.innerHTML = `
    <div class="footer-row">
      <div>&copy; HE SHAOLIANG &middot; ${year}</div>
      <div>BUILT IN SINGAPORE &middot; HTML &amp; STUBBORNNESS</div>
      <div>v0.3 · <span class="foot-caveat">always shipping</span></div>
    </div>
  `;
  container.appendChild(footer);
}

export function initFooter() {
  // No-op kept for API compatibility with project-detail.js.
}
